import { Button } from "@amzn/awsui-components-react/polaris";
import { getExcaliburAuditData } from '../../excalibur/components/excaliburAPIs';
import orderBy from 'lodash/orderBy';
import {populateReportingPeriod} from "../utils/Utils"
import {REMOTE_FILING_TRANSACTION_TYPE} from "../../../common/constants/constants";

export const INITIAL_STATE = {
    data: [],
    reportingPeriod: null,
    periodList: [],
    lastEvaluatedKey: null,
    auditData: new Map(),
    pageCount: 1,
    currentPageIndex: 1,
    sortingColumn: { "sortingField": "startTimestamp" },
    sortingDescending: true,
    loading: true,
    loadingText: "Loading requests",
    initialize: true,
    filePath: {},
    flashBarItem: [],
    submitted: false,
    fileSummaryData : null
};

export const filingReducerInit = initialState => {
    return initialState;
}


export const filingReducer = (state, action) => {
    switch (action.type) {
        case "API_RESPONSE": 
            const currentOrder = state.sortingDescending ? 'desc' : 'asc';
            state.auditData.set(state.currentPageIndex, orderBy(action.payload.data,
                state.sortingColumn.sortingField, currentOrder));
            return {
                ...state,
                loading: false,
                initialize: false,
                lastEvaluatedKey: action.payload.lastEvaluatedKey,
                // A non-null lastEvaluatedKey means DDB has more data, so allow one
                // more page than the current index; otherwise cap at the current index.
                pageCount: action.payload.lastEvaluatedKey
                    ? state.currentPageIndex + 1
                    : state.currentPageIndex,
            }
        case "CREATE_FILE_PATH_SUCCESS":
            return {
                ...state,
                filePath: action.payload?.data
            }
        case "TRANSMIT_FILE_REQUEST_COMPLETED":
            if(action.payload.fetchAudit){
                getExcaliburAuditData(action.payload.dispatcher, null, REMOTE_FILING_TRANSACTION_TYPE);
            }   
            return {
                ...state,
                submitted: true
            }

        case "SET_FLASH_BAR":
            let buttonCTA = action.payload.type === 'success' ? 'Continue Filing' : 'Retry';
            window.scrollTo(0,0);
            return {
                ...state,
                flashBarItem: [{
                    type: action.payload?.type,
                    action: action.payload?.handleFlashBarAction ? <Button onClick={action.payload?.handleFlashBarAction}>{buttonCTA}</Button> : null,
                    dismissible: true,
                    dismissLabel: "Dismiss message",
                    onDismiss: action.payload?.handleFlashBarAction? () => {
                        action.payload?.dispatcher({ type: "DISMISS_FLASHBAR", payload: {} })
                    } : null ,
                    content: (
                        <>
                            {action.payload?.msg}
                        </>
                    ),
                    id: "message_1"
                }]
            }
        case "FAILURE_API_RESPONSE":
            return {
                ...state,
                initialize: false,
            }
        case "AUTH_UPDATE":
            console.log(action.payload)
            return {
                ...state,
                isUserAuthenticatedWithTaxAuthority : action.payload.isUserAuthenticatedWithTaxAuthority
            }
        case "SET_AUTH_CODE":
            return {
                ...state,
                authCode: action.payload?.data
            }
        case "SET_REPORTING_PERIOD":
            const data = populateReportingPeriod(action.payload?.periodList);
            return {
                ...state,
                reportingPeriod: data,
                periodList: action.payload?.periodList
            }
        case "DISMISS_FLASHBAR":
            return {
                ...state,
                flashBarItem: []
            }
        
        case "PAGE_INDEX_CHANGED":
            if (state.auditData.has(action.payload.pageIndex) === false) {
                if (state.lastEvaluatedKey === null) {
                    // If the above condition is true,
                    // it means DDB has returned complete data and no data is left to show
                    state.auditData.set(action.payload.pageIndex, []);
                } else {
                    // Audit table only; the Transaction Details task table pages itself in FilingTable.
                    getExcaliburAuditData(action.payload.dispatcher, state.lastEvaluatedKey, REMOTE_FILING_TRANSACTION_TYPE);
                }
            }
            return {
                ...state,
                currentPageIndex: action.payload.pageIndex,
            }
        case "RESET_STATE": 
            return {
                ...state,
                periodList : action.payload.periodList,
                filePath : action.payload.filePath,
                fileSummaryData : action.payload.fileSummaryData,
                flashBarItem : action.payload.flashBarItem,
                submitted : action.payload.submitted,
                reportingPeriod : action.payload.reportingPeriod
            } 
        case "SET_SUMMARY_DATA": 
            return {
                ...state,
                fileSummaryData : action.payload.fileSummaryData
            }  
        case "AUDIT_SORTING_CHANGED":
            let newOrder = action.payload.isDescending ? 'desc' : 'asc';
            state.loading= true
            let sortedPageItems = orderBy(state.auditData.get(state.currentPageIndex),action.payload.sortingField,newOrder);
            state.auditData.set(state.currentPageIndex, sortedPageItems);
            return {
                ...state,
                loading: false,
                sortingDescending:action.payload.isDescending,
                sortingColumn:{"sortingField":action.payload.sortingField}
            }
        case "REFRESH_AUDIT":
            getExcaliburAuditData(action.payload.dispatcher, state.lastEvaluatedKey, REMOTE_FILING_TRANSACTION_TYPE);
            // Return a fresh state with a new Map so we don't share the mutated
            // auditData Map from the module-level INITIAL_STATE (which caused stale
            // rows after switching transactions).
            return { ...INITIAL_STATE, auditData: new Map() }

        default:
            return state;
    }
}